/**
 * @generated SignedSource<<c485572e0c25e52457cb71e8e531410b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserMembershipEntity = "occurrence" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OrganizationGuestListRow_Member$data = {
  readonly createdAt: string;
  readonly email: string | null;
  readonly hasBeenInvited: boolean | null;
  readonly id: string;
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarWithDetailsFragment">;
  };
  readonly userMemberships: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entity: UserMembershipEntity;
        readonly id: string;
        readonly occurrence: {
          readonly name: string | null;
        } | null;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationGuestListActionDropdownFragment">;
  readonly " $fragmentType": "OrganizationGuestListRow_Member";
};
export type OrganizationGuestListRow_Member$key = {
  readonly " $data"?: OrganizationGuestListRow_Member$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationGuestListRow_Member">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganizationGuestListRow_Member",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBeenInvited",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrganizationGuestListActionDropdownFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserMembershipNodeConnection",
      "kind": "LinkedField",
      "name": "userMemberships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserMembershipNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entity",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Occurrence",
                  "kind": "LinkedField",
                  "name": "occurrence",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfileAvatarWithDetailsFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuestMembership",
  "abstractKey": null
};
})();

(node as any).hash = "2c379ca2edeac70c06b548caba76d1f8";

export default node;
